"use client"

import { useState, useEffect } from "react"
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion"
import "./experience.css"
import { experienceData, slideVariants, techVariants } from "./Experience.ts"


export default function ExperienceSection() {

  const { t } = useTranslation()

  const [currentSlide, setCurrentSlide] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % experienceData.length)
    }, 5000)

    return () => clearInterval(interval)
  }, [])

  return (
    <section id="experience" className="experience-section">
      <div className="experience-container">
        <motion.div
          className="experience-header"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h4 className="experience-subtitle">{t("experience.subtitle")}</h4>
          <h2 className="experience-title">{t("experience.title")}</h2>
        </motion.div>

        <div className="slides-container">
          <AnimatePresence mode="wait" custom={experienceData[currentSlide].direction}>
            <motion.div
              key={currentSlide}
              custom={experienceData[currentSlide].direction}
              variants={slideVariants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{
                x: { type: "spring", stiffness: 300, damping: 30 },
                opacity: { duration: 0.5 },
              }}
              className="slide"
            >
              <motion.h3
                className="slide-title"
                style={{ color: experienceData[currentSlide].color }}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.2, duration: 0.5 }}
              >
                {experienceData[currentSlide].title}
              </motion.h3>

              <div className="technologies-grid">
                {experienceData[currentSlide].technologies.map((tech, index) => (
                  <motion.div
                    key={tech.name}
                    custom={index}
                    variants={techVariants}
                    initial="hidden"
                    animate="visible"
                    className="tech-card"
                    whileHover={{
                      scale: 1.05,
                      boxShadow: `0 10px 25px ${experienceData[currentSlide].color}20`,
                    }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <div className="tech-icon">{tech.icon}</div>
                    <div className="tech-info">
                      <h5 className="tech-name">{tech.name}</h5>
                      <p className="tech-level">{tech.level}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="slide-indicators">
          {experienceData.map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === currentSlide ? "active" : ""}`}
              onClick={() => setCurrentSlide(index)}
              style={{
                backgroundColor: index === currentSlide ? experienceData[index].color : "transparent",
                borderColor: experienceData[index].color,
              }}
            />
          ))}
        </div>
      </div>
    </section>
  )
}
